var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCzResidential(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 46.27l9.58-11.4.07-.09a8.66 8.66 0 005.66-8.12 8.57 8.57 0 00-2-5.56 5.579 5.579 0 00-7.35-6.7 8.19 8.19 0 00-15.39 0 5.482 5.482 0 00-1.9-.4 5.58 5.58 0 00-5.46 6.72 8.64 8.64 0 003.73 14l9 10.68V61H44V37.21L23.59 23 3 37.57V65h70v-4H60V46.27zM40 61H27v-9h-7v9H7V39.64l16.61-11.75L40 39.3V61zm13.39-24.83c1.615.335 3.26.502 4.91.5a23.78 23.78 0 004.88-.49L58.33 42l-4.94-5.83zM34 47h-7v-7h7v7zm-21-7h7v7h-7v-7z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/CZ_Residential.e3931642.svg";
export { SvgCzResidential as ReactComponent };